import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=abbae49a&scoped=true"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"
import style0 from "./FileField.vue?vue&type=style&index=0&id=abbae49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbae49a",
  null
  
)

export default component.exports